import { utils } from "../../utils/Utils";

export type ProductURLInfo  = {
    productId:string,
    masterId:string,
    businessId:string,
    isBundle:boolean,
    isVariant:boolean,


}

export const productURL = "/product-details/";
export const productURLBundleTag = "bundle";
export const productURLVariantTag = "v";

export default function GetProductInfoFromURL(url:string,multiLocationData:any,inBusiness?:string) :ProductURLInfo {


    if(!url||url.length<0){
        url = window.location.pathname;
    }


    const returnData = {productId:"",masterId:"",businessId:inBusiness??"",isBundle: false,isVariant:false};

    const isMysiteDomain = (window.origin.includes(utils.MySiteName())||window.origin.includes("localhost"))


    let split = url.split("/").filter((x)=>x.length>0&&x!="preview");
    split = (isMysiteDomain) ? split.slice(4): split.slice(3);

    if(split[0] === productURLVariantTag){
        returnData.isVariant = true;
        split.shift();
    }

    if(split.length==3){

        returnData.businessId = decodeURIComponent(split[0]??"");
        returnData.masterId = decodeURIComponent(split[1]??"");
        returnData.productId = decodeURIComponent(split[2]??"");

    }
    else if(returnData.isVariant){
        returnData.businessId = decodeURIComponent(split[0]??"");
        returnData.productId = decodeURIComponent(split[1]??"");
        returnData.masterId = "";
    }
    else{
        returnData.businessId = decodeURIComponent(split[0]??"");
        returnData.masterId = decodeURIComponent(split[1]??"");
        returnData.productId = returnData.masterId;

    }


    return returnData;

}

export  function GenerateProductURLPrefix(inventoryId:string,brusinessId:string,isVariant:boolean,pName?:string,pBrand?:string){

    let prv = (window.location.href.endsWith("/preview")||window.location.href.endsWith("/preview/"))?"preview":"";
    let varStr = (isVariant)?"v/":"";
    let url = 'product-details/'
    if(pName&&pBrand){
       url += encodeURI(`${productSanatize(pBrand)}/${productSanatize(pName)}/`).replaceAll("+","-").replaceAll("#","") ;
    }
    url += varStr  + encodeURI(brusinessId) + "/"+ encodeURI(inventoryId) + "/" + prv;
    return url;
}

function productSanatize(str: string) {
    return (str || "")
        .trim()
        .replace(/[,;:'"!?@$%^*()[\]{}<>|\\&+=~`]/g, "")
        .replace(/[^a-zA-Z0-9]+/g, "-")
        .replace(/-+/g, "-")
        .replace(/^-|-$/g, "")
        .toLowerCase();

}

export   function GetItemBundleInfoFromData(data:any){

    let maxQuantity = 999999999;
    let includedItems:string [] = []
    for(let i = 0;i<data.length;i++){
        let item = data[i];

        if(item.isTrackInventory&&item.totalQty<maxQuantity){
            maxQuantity = item.totalQty;
        }

       let desc=item.name;
        if(item.bundleQty>1)
            desc+=` x ${item.bundleQty} Qty`;

        includedItems.push(desc);
    }

    return {
        maxQuantity:maxQuantity,
        includedItems:includedItems,
    }

}
